import { Text } from '@fluentui/react-components';
import { useByodSectionStyles } from './ByodSection.styles';
import { IByodSectionProps } from './ByodSection.types';
import HorizontalLine from '../../../../../components/core/HorizontalLine/HorizontalLine';

const ByodSection = (props: IByodSectionProps) => {
    const styles = useByodSectionStyles();

    const HandleViewReceipt = () => {
        const reader = new FileReader();
        reader.onload = function () {
            const blobUrl = URL.createObjectURL(props.byod.file);
            window.open(blobUrl, '_blank');
        };
        reader.readAsDataURL(props.byod.file);
    };

    return (
        <div className={styles.byodContainer}>
            <b className={styles.itemTitle}>Bring Your Own Device</b>

            <Text>
                Device you are bringing: {props.byod.make} {props.byod.model}
            </Text>

            <Text>IMEI: {props.byod.imei}</Text>

            <div
                className={styles.viewReceiptLink}
                onClick={HandleViewReceipt}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === 'Space') HandleViewReceipt();
                }}
            >
                Purchase Receipt
            </div>

            <HorizontalLine />
        </div>
    );
};

export default ByodSection;
